<template>
  <div>
    <div class="msg-tab">
      <div
        v-for="(item, i) in typeList"
        :key="i"
        style="cursor: pointer"
        :class="['all', { activeFont: activeFont == i }]"
        @click="switchTab(i, item.autoInt)"
      >
        {{ item.typeName }}
      </div>
    </div>
    <div class="msg-list-box">
      <div v-if="noteList && noteList.length > 0">
        <div
          class="msg-list"
          @click="see(item)"
          v-for="(item, i) in noteList"
          :key="i"
        >
          <div class="list-left">
            <div class="list-title">{{ item.title }}</div>
          </div>
          <div class="list-center">{{ item.describe }}</div>
          <div class="list-time">
            {{
              item.publishDate
                ? item.publishDate && item.publishDate.slice(0, 10)
                : item.createDate && item.createDate.slice(0, 10)
            }}
          </div>
        </div>
      </div>
      <el-empty v-else description="暂无数据"></el-empty>
    </div>
    <el-dialog
      :title="messageDetail.newsTypeName"
      :visible.sync="dialogVisible"
      width="1000px"
      append-to-body
    >
      <div class="detail-box">
        <div class="title">{{ messageDetail.title }}</div>
        <div class="time">
          {{
            messageDetail.publishDate
              ? messageDetail.publishDate
              : messageDetail.createDate
          }}
        </div>
        <div class="content" v-html="messageContent"></div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { formatRichText } from "@/utils/function";
export default {
  //import引入组件才能使用
  components: {},
  props: {},
  data() {
    return {
      noteList: [],
      readCount: 0,
      unreadCount: 0,
      activeFont: false,
      dialogVisible: false,
      messageContent: "",
      messageDetail: "",
      activeFont: false,
      typeList: "",
    };
  },
  // 计算属性
  computed: {},
  // 监听data中的数据变化
  watch: {},
  // 生命周期：挂载完成时（可以访问DOM元素）
  mounted() {
    this.NewsTypeList();
  },
  // 方法集合
  methods: {
    NewsTypeList() {
      let sendData = {
        topNum: 3,
      };

      this.$api.manage.NewsTypeList(sendData).then((res) => {
        if (res.code === 0) {
          this.typeList = res.data;
          this.NewsRead_List(this.typeList[0].autoInt);
        }
      });
    },
    switchTab(flag, autoInt) {
      this.activeFont = flag;
      this.NewsRead_List(autoInt);
    },
    NewsRead_List(autoInt) {
      let sendData = {
        typeAutoInt: autoInt,
      };

      this.$api.manage.NewsRead_List(sendData).then((res) => {
        if (res.code === 0) {
          this.noteList = res.data;
        }
      });
    },
    async getDetail(data) {
      let sendData = {
        id: data.id,
      };
      await this.$api.manage.Read_Detail(sendData).then((res) => {
        if (res.error === false) {
          this.messageContent = formatRichText(res.data.content);
          this.messageDetail = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    async see(v) {
      await this.getDetail(v);
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang='less' scoped>
.detail-box {
  padding: 0 25px 0 30px;
  margin-top: -15px;

  .title {
    font-size: 20px;
    color: black;
    font-weight: 600;
  }
  .time {
    margin: 20px 0 20px 0;
    font-size: 12px;
  }
  .content {
    max-height: 52vh;
    overflow: auto;
    padding-right: 4px;
  }
}

.msg-tab {
  display: flex;

  justify-content: right;
  .all {
    // width: 80px;
    padding: 0 13px;
    height: 28px;
    // background-color: #e6e6e6;
    border-radius: 5px 5px 0px 0px;
    text-align: center;
    line-height: 28px;
  }
}
.activeFont {
  background-color: #4e89f7 !important;
  color: #fff;
}
.msg-list-box {
  border-top: 1px solid #4e89f7;
  height: 253px;
  overflow: auto;

  .msg-list {
    width: 100%;
    padding: 10px 0px 5px;
    // display: flex;
    // justify-content: space-between;
    border-bottom: 1px solid #dee7ff;
    cursor: pointer;
    .list-left {
      display: flex;
      .list-title {
        width: 365px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .list-time {
      // width: 67px;
      font-size: 12px;
      margin-right: 30px;
      margin-top: 10px;
    }
    .list-center {
      font-size: 12px;
      width: 365px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #909399;
      margin-top: 10px;
    }
    .list-right {
    }
  }
}
</style>